import type { RobotCleaningProgressEntry } from './robotCleaningProgressSlice';
import type { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import type { Optional } from 'lib/types/Optional';

export const selectRobotCleaningProgressEntry = (
  state: IState,
  robotId: string
): Optional<RobotCleaningProgressEntry> =>
  state.modules['machine-inventory']['robot-cleaning-progress'].byRobotId[robotId];
